import * as React from 'react'

const SvgChartLineDataIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.287 11.175c.193.047.39.072.588.075a2.5 2.5 0 001.394-.425l2.012 1.794a2.426 2.426 0 00-.125 1.981 2.5 2.5 0 103.981-2.725l1.588-3.181a2.363 2.363 0 001.819-.332 2.5 2.5 0 10-2.931-.237l-1.588 3.181a2.5 2.5 0 00-1.919.369L9.094 9.881A2.425 2.425 0 009.219 7.9a2.5 2.5 0 10-4.031 2.681L2.5 15.625V1.25H1.25V17.5c0 .69.56 1.25 1.25 1.25h16.25V17.5H2.919l3.368-6.325zM16.25 5a1.25 1.25 0 110 2.5 1.25 1.25 0 010-2.5zm-2.5 8.75a1.25 1.25 0 11-2.5 0 1.25 1.25 0 012.5 0zM6.875 7.5a1.25 1.25 0 110 2.5 1.25 1.25 0 010-2.5z"
      fill="#163250"
    />
  </svg>
)

export default SvgChartLineDataIcon
